import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITableColumns } from 'app/modules/reports/interfaces/reporting-data';

@Component({
    selector: 'dynamic-dialog',
    templateUrl: './dynamic-dialog.component.html',
    styleUrl: './dynamic-dialog.component.scss',
})
export class DynamicDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IDynamicDialogData,
        private dialogRef: MatDialogRef<DynamicDialogComponent>
    ) {}

    tableColumns: ITableColumns[] = [];
    tableData: Array<any> = [];

    ngOnInit() {
        this.tableColumns = this.data?.columnList;
        this.tableData = this.data?.tableData;
    }

    crossClicked() {
        this.dialogRef.close();
    }
}

export interface IDynamicDialogData {
    columnList: ITableColumns[];
    tableData: Array<any>;
}
